import PropTypes from "prop-types";
import { LocaleContext } from "../LocaleProvider";

export const withTranslation = Component => {
  const ComposedComponent = props => (
    <LocaleContext.Consumer>
      {localeValues => {
        if (!localeValues) {
          localeValues = {
            formatTranslation: () => "",
            formatLink: () => "",
            formatCurrency: () => "",
            formatNumber: () => ""
          };
        }

        return (
          <Component
            {...props}
            formatTranslation={localeValues.formatTranslation}
            formatLink={localeValues.formatLink}
            formatCurrency={localeValues.formatCurrency}
            formatNumber={localeValues.formatNumber}
          />
        );
      }}
    </LocaleContext.Consumer>
  );

  ComposedComponent.displayName = `withTranslation(${
    Component.displayName || Component.name || "Component"
  })`;
  ComposedComponent.WrappedComponent = Component;
  ComposedComponent.initActions = Component.initActions;

  return ComposedComponent;
};

const Translation = ({ formatTranslation, id, values }) => (
  <span>{formatTranslation(id, values)}</span>
);

Translation.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  values: PropTypes.object
};

export default withTranslation(Translation);
